
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CandidateDetail } from '../../../../models/candidate-detail.model';
import { InformationLabel, InformationList, Linked, LinkExt, LockedMedicalReportContainer, SectionBlock, Title } from '../../talent.styled';
import { LockedContent } from '../locked-content/locked-content';

interface PcDsProps {
    candidate?: CandidateDetail | null;
    isLocked: boolean;
}

const PcDs: React.FC<PcDsProps> = ({ isLocked, candidate }) => {
    const { t } = useTranslation('private-home-page');
    return (
        <>
            {candidate && candidate?.pcd?.length > 0 &&
                <SectionBlock>
                    <Title>{t('talent.pcd')}</Title>
                    <InformationList>
                        {isLocked && <LockedMedicalReportContainer>
                            <span>{t('talent.medical_report')}</span><LockedContent />
                        </LockedMedicalReportContainer>}
                        {candidate?.pcd?.map((pcd, index) => isLocked || !pcd?.medical_report_url ? (
                            <InformationLabel key={`${index}-${pcd.name}`}>
                                {pcd.name}
                                {pcd?.cid && <> | CID - {pcd?.cid} </>}
                            </InformationLabel>
                        ) : (
                            <InformationLabel key={`${index}-${pcd.name}`}>
                                <Linked target="_blank" href={pcd.medical_report_url} rel="noopener noreferrer">
                                    {pcd.name}
                                    {pcd?.cid && <> | CID - {pcd?.cid} </>}
                                    <LinkExt src="/assets/img/link-ext.svg" />
                                </Linked>
                            </InformationLabel>
                        ))}
                    </InformationList>
                </SectionBlock>
            }
        </>
    );
}

export default PcDs;
